export default __webpack_public_path__ + "static/media/mushroom-parent-and-child--back.c506ac41.jpg";